import { NavLink } from 'react-router-dom'

const TABS = [
  { to: '/records', label: '📊 歷史記錄' },
  { to: '/charts', label: '📈 數據圖表' },
  { to: '/formula', label: '🧪 藥水配方' },
]

export default function NavBar() {
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 grid grid-cols-3 border-t-4 border-white bg-navy-800">
      {TABS.map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          className={({ isActive }) =>
            `py-4 text-center text-lg font-bold ${
              isActive ? 'bg-navy-700 text-white' : 'bg-navy-800 text-gray-300'
            }`
          }
        >
          {tab.label}
        </NavLink>
      ))}
    </nav>
  )
}
